module.exports = __webpack_public_path__ + "img/gate-rail-base-vertical.fa518b0d.png";